const DEALERSHIP_PERMISSIONS = [
	{ key: 1, value: 'buyer', label: 'Buying', railsValue: 0 },
	{ key: 2, value: 'seller', label: 'Selling', railsValue: 1 },
	{ key: 3, value: 'both', label: 'Buying and Selling', railsValue: 1 },
];

export default DEALERSHIP_PERMISSIONS;
